import { MapPin, Clock, Route as RouteIcon } from "lucide-react";

export default function BikePathCard({ p, onClick }) {
  return (
    <button onClick={onClick} data-testid={`rider-path-card-${p.id}`}
      className="group w-full text-left rounded-2xl overflow-hidden bg-card border border-border active:scale-[0.98] transition-transform duration-150">
      <div className="relative h-36 bg-secondary">
        {p.cover_image ? (
          <img src={p.cover_image} alt={p.name} className="w-full h-full object-cover" loading="lazy" />
        ) : (
          <div className="w-full h-full bg-gradient-to-br from-primary/40 via-primary/10 to-secondary flex items-center justify-center">
            <RouteIcon className="w-8 h-8 text-primary/60" />
          </div>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/10 to-transparent" />
        <div className="absolute bottom-2.5 left-3 right-3">
          <div className="font-heading font-bold text-white text-lg leading-tight drop-shadow">{p.name}</div>
          <div className="text-white/85 text-xs flex items-center gap-2.5 mt-1 flex-wrap">
            {p.length_mi != null && <span className="inline-flex items-center gap-1"><MapPin className="w-3 h-3" />{p.length_mi} mi</span>}
            {p.estimated_ride_time && <span className="inline-flex items-center gap-1"><Clock className="w-3 h-3" />{p.estimated_ride_time}</span>}
            {p.distance_mi != null && <span className="text-primary-foreground/90 bg-primary/80 px-1.5 py-0.5 rounded-full text-[10px] font-semibold">{p.distance_mi < 0.1 ? "At trailhead" : `${p.distance_mi} mi away`}</span>}
          </div>
        </div>
      </div>
    </button>
  );
}
